export default __webpack_public_path__ + "static/media/MuseoSansRounded-300.54a0ae4c.woff2";